/**
 * Password validation regex pattern
 *
 * Requirements:
 * - At least one lowercase letter
 * - At least one uppercase letter
 * - At least one digit
 * - At least one special character from: !@#$%^&*,?=._:;+"'\/()[]{}
 * - Only contains allowed characters (letters, digits, and listed special characters)
 */
export const PASSWORD_STRENGTH_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^ˆ&*,?=._:;+"'\\/()[\]{}<>-])[A-Za-z\d!@#$%^ˆ&*,?=._:;+"'\\/()[\]{}<>-]+$/;
